import { render, staticRenderFns } from "./ContractsPurchaseSaleDetailList.vue?vue&type=template&id=d5715fd8"
import script from "./ContractsPurchaseSaleDetailList.vue?vue&type=script&lang=js"
export * from "./ContractsPurchaseSaleDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports